<template>
  <el-form
    ref="form"
    :model="form"
    :rules="rules"
    label-position="top"
    class="server-form"
  >
    <el-form-item
      prop="fileList"
    >
      <!--
      :on-success="handleSuccess"
      -->
      <el-upload
        ref="upload"
        class="upload-demo"
        drag
        action="''"
        :limit="5"
        :http-request="uploadCenterLogoHandle"
        :on-remove="handleRemove"
        :before-upload="beforeAvatarUpload"
        :file-list="form.fileList"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或点击上传</div>
        <div class="el-upload__tip" slot="tip">
          <p>只能导入xls和xlsx文件， <a class="demo-template" :href="url" download target="_blank">下载模板</a></p>
        </div>
        <!--文件名没有显示 todo -->
      </el-upload>
    </el-form-item>
  </el-form>
</template>

<script>
import { uploadFile } from '@/utils/uploadFile'
let orginForm = {
  fileList: [],
}
export default {
  name: "importForm",
  data() {
    return {
      url: 'https://alita.oss-cn-shenzhen.aliyuncs.com/files/ca6175e630b84439bc8a6ef3651290d0.xlsx',
      form: orginForm,
      rules: {
        fileList: [
          { required: true,message: "请选择文件上传",trigger: 'change'},
        ],
      },
    }
  },
  methods: {
    selfValidate(){
      this.$refs.form.validate((valid) => {
        if(valid){
          this.$emit('submit',this.form);
        }else {
          console.log('no-pass');
        }
      })
    },
    selfClear(){
      this.$refs.form.clearValidate();
      this.$refs.form.resetFields();
      this.reset();
    },
    reset(){
      this.form = orginForm;
      this.form.fileList = [];
    },
    handleRemove(file){
      this.form.fileList = [];
    },
    handleSuccess(response){
      /*console.log(response);
      // 改为上传fileName,提交到后台的时候处理
      response.data.content[0].name = this.currentFileName;
      this.form.fileList = [response.data.content[0]];
      this.$refs.upload.clearFiles();*/
    },
    beforeAvatarUpload(file) {
      const isHtml = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      if (!isHtml) {
        this.$message.error('请上传.xls,.xlsx文件');
      }
      this.currentFileName = file.name;
      // 文件流,这里需要传文件流 todo
      return isHtml;
    },
    uploadCenterLogoHandle(res){
      uploadFile(res.file).then(rs => {
        if (rs.data.code === 200) {
          this.form.fileList.push({
            name: res.file.name,
            url: rs.data.url,
          });
        } else {
          this.$message.error("文件上传失败：" + data.msg)
        }
      })
    },
  },
}
</script>

<style scoped>

</style>
